module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_35.a48f2851.jpeg";